import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { masterStyles } from './MasterCssClass';
import { FiCreditCard, FiFileText, FiUsers, FiCalendar, FiLogOut, FiMenu, FiX } from 'react-icons/fi';

const Sidebar = ({ handleLogout }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;

  const isActive = (path) => currentPath === path || (path === '/invoice' && currentPath === '/');

  return (
    <>
      {/* Mobile Hamburger Button Bar */}
      <div className="print:hidden md:hidden flex items-center justify-between bg-[#358156] text-white p-2.5">
        <span className="font-bold text-xs uppercase">Dashboard Portal</span>
        <button 
          onClick={() => setMobileOpen(!mobileOpen)} 
          className="p-1 focus:outline-none"
          aria-label="Toggle Menu"
        >
          {mobileOpen ? <FiX size={20} /> : <FiMenu size={20} />}
        </button>
      </div>

      {/* Backdrop overlay for mobile */}
      {mobileOpen && (
        <div 
          onClick={() => setMobileOpen(false)} 
          className="fixed inset-0 bg-black/40 z-30 md:hidden print:hidden" 
        />
      )}

      {/* Sidebar Container (Reduced width to w-48) */}
      <aside className={`
        print:hidden
        fixed md:relative z-40 inset-y-0 left-0 transform 
        ${mobileOpen ? 'translate-x-0' : '-translate-x-full'} 
        md:translate-x-0 transition-transform duration-200 ease-in-out
        bg-white shadow-md md:shadow-none flex flex-col h-screen md:h-full w-48 shrink-0 border-r border-slate-200
      `}>
        <div className={masterStyles.sidebarHeader}>
          <div className={masterStyles.brandContainer}>
            <span className={masterStyles.brandTitle}>SIXFOX TECHNOLOGY</span>
            <span className={masterStyles.brandSubtitle}>Management Portal</span>
          </div>
        </div>

        {/* Navigation Items (Scrollable) */}
        <div className="flex-1 overflow-y-auto p-1 space-y-1 mt-1" onClick={() => setMobileOpen(false)}>
          <div className={masterStyles.itemsContainer}>
            <Link 
              to="/invoice" 
              className={isActive('/invoice') ? masterStyles.activeNavItem : masterStyles.inactiveNavItem}
            >
              <FiFileText className={isActive('/invoice') ? masterStyles.activeIcon : masterStyles.inactiveIcon} size={16} />
              <span className={masterStyles.itemLabel}>Invoice Generator</span>
            </Link>

            {/* <Link 
              to="/aky-billing" 
              className={isActive('/aky-billing') ? masterStyles.activeNavItem : masterStyles.inactiveNavItem}
            >
              <FiFileText className={isActive('/aky-billing') ? masterStyles.activeIcon : masterStyles.inactiveIcon} size={16} />
              <span className={masterStyles.itemLabel}>AKY Billing</span>
            </Link> */}

            <Link 
              to="/client" 
              className={isActive('/client') ? masterStyles.activeNavItem : masterStyles.inactiveNavItem}
            >
              <FiUsers className={isActive('/client') ? masterStyles.activeIcon : masterStyles.inactiveIcon} size={16} />
              <span className={masterStyles.itemLabel}>Client Master</span>
            </Link>

            <Link
              to="/companyBankingDetails"
              className={isActive('/companyBankingDetails') ? masterStyles.activeNavItem : masterStyles.inactiveNavItem}
            >
              <FiCreditCard className={isActive('/companyBankingDetails') ? masterStyles.activeIcon : masterStyles.inactiveIcon} size={16} />
              <span className={masterStyles.itemLabel}>Company Banking Details</span>
            </Link>

            <Link
              to="/sessions"
              className={isActive('/sessions') ? masterStyles.activeNavItem : masterStyles.inactiveNavItem}
            >
              <FiCalendar className={isActive('/sessions') ? masterStyles.activeIcon : masterStyles.inactiveIcon} size={16} />
              <span className={masterStyles.itemLabel}>Session Master</span>
            </Link>
          </div>
        </div>

        {/* Footer Logout Button (Pinned to Bottom) */}
        <div className={masterStyles.footerContainer}>
          <button onClick={handleLogout} className={masterStyles.dashboardButton}>
            <FiLogOut size={14} />
            <span>Logout System</span>
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;